if (!customElements.get('dk-sticky-purchase')) {
  customElements.define('dk-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.main = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.main || this.main.dataset.productId !== this.dataset.productId) return;
      this.queue = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.queue, { passive: true, signal });
      window.addEventListener('resize', this.queue, { passive: true, signal });
      document.addEventListener('focusin', this.queue, { signal });
      document.addEventListener('focusout', this.queue, { signal });
      document.addEventListener('click', this.queue, { signal });
      document.addEventListener('transitionend', this.queue, { signal });
      document.addEventListener('toggle', this.queue, { signal, capture: true });
      window.visualViewport?.addEventListener('resize', this.queue, { signal });
      this.querySelector('button').addEventListener('click', () => this.returnToPurchase(), { signal });
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this.main, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.resizeObserver = new ResizeObserver(this.queue);
      this.resizeObserver.observe(this.main);
      this.queue();
    }
    mainButton() {
      return this.main?.querySelector('product-form button[name="add"]');
    }
    headerBottom() {
      const header = document.querySelector('.section-header, .shopify-section-header');
      if (!header) return 0;
      const rect = header.getBoundingClientRect();
      return rect.top <= 0 && rect.bottom > 0 ? rect.bottom : 0;
    }
    update() {
      const button = this.mainButton();
      const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]),textarea,select,[contenteditable="true"]');
      const keyboard = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
      const blocked = Array.from(document.querySelectorAll('[role="alertdialog"],[aria-modal="true"],dialog[open]')).some(el => {
        if (el.closest('details:not([open]),[hidden],[aria-hidden="true"]')) return false;
        const style = getComputedStyle(el);
        return el.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
      });
      this.hidden = !window.matchMedia('(max-width:749px)').matches || !button || !button.getClientRects().length || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getBoundingClientRect().bottom >= this.headerBottom() || editing || keyboard || blocked;
    }
    returnToPurchase() {
      const button = this.mainButton();
      if (!button) return;
      const picker = this.main.querySelector('variant-selects');
      const quantity = this.main.querySelector('quantity-input');
      const anchor = picker || quantity || button;
      const focusTarget = picker?.querySelector('input:checked:not(:disabled),select:not(:disabled)') || button;
      this.hidden = true;
      const header = document.querySelector('.section-header, .shopify-section-header');
      const headerSpace = Math.max(this.headerBottom(), header?.getBoundingClientRect().height || 0);
      const top = Math.max(0, anchor.getBoundingClientRect().top + window.scrollY - headerSpace - 20);
      focusTarget.focus({ preventScroll: true });
      window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
